import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const ReferenceRoomContext = React.createContext({
  state: { referenceroomList: {}, referenceroom: {} },
  actions: {
    getReferenceRoom: () => {},
    getReferenceRoomList: () => {},
  },
});

const ReferenceRoomProvider = ({ children }) => {
  const [referenceroom, setReferenceRoom] = useState({});
  const [referenceroomList, setReferenceRoomList] = useState([]);
  
  const getReferenceRoomList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/admin/reference/list", 
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        referenceTitle: pageInfo && pageInfo.referenceTitle,
      }
    }).then((res) => {
      if (res.code === 200) {
        setReferenceRoomList(res.data);
      } else {
      }
    });
  }, []);

  const getReferenceRoom = useCallback((referenceId) => {
    HttpAction({
      url:"api/admin/reference", 
      method: "get",
      params: {
        referenceId: referenceId
      }
    }).then((res) => {
      if (res.code === 200) {
        setReferenceRoom(res.data); 
      } else {
      }
    });
  }, []);

  const createReferenceRoom = useCallback(async(referenceroomData,setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
      .post(`api/admin/reference/save`, referenceroomData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getReferenceRoomList({})
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      }); 
    
  }, []);

  const updateReferenceRoom = useCallback(async(referenceroomData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
      .post(`api/admin/reference/modify`, referenceroomData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,

        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
        }
      });
  }, []);

  const deleteReferenceRoom = useCallback((referenceId, history, url) => {
    HttpAction({
      url: "api/admin/reference",
      method: "delete",
      params: {
        referenceId: referenceId
      }
    }).then((res) => {
      if (res.code === 200) {
      history.push(url)
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { referenceroom, referenceroomList },
    actions: { getReferenceRoomList, getReferenceRoom, createReferenceRoom, updateReferenceRoom, deleteReferenceRoom },
  };

  return (
    <ReferenceRoomContext.Provider value={value}>
      {children}
    </ReferenceRoomContext.Provider>
  );
};

const { Consumer: ReferenceRoomConsumer } = ReferenceRoomContext;

export { ReferenceRoomProvider, ReferenceRoomConsumer, ReferenceRoomContext };

export default ReferenceRoomContext;
